module.exports = __webpack_public_path__ + "img/75.de535e3b.png";